import { deviceTypeAction } from "../action/deviceTypes.action";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deviceTypes: null,
};

const deviceTypes = createSlice({
  name: "deviceTypes",
  initialState: initialState,
  reducers: deviceTypeAction,
});

export const { setDeviceTypes } = deviceTypes.actions;

export default deviceTypes.reducer;
